import axiosInstanceNew from "../lib/axiosinstanceNew";

const ClientBalanceModel = class {
  constructor() {
    this.baseUrl = "client_balance";
    this.staticData = [
      {
        id: 1,
        auth_user: {
          first_name: "Rahul",
          last_name: "Sharma",
        },
        price_parent: 50000,
        paid_amount: 35000,
      },
      {
        id: 2,
        auth_user: {
          first_name: "Priya",
          last_name: "Patel",
        },
        price_parent: 75000,
        paid_amount: 60000,
      },
      {
        id: 3,
        auth_user: {
          first_name: "Amit",
          last_name: "Verma",
        },
        price_parent: 40000,
        paid_amount: 25000,
      },
      {
        id: 4,
        auth_user: {
          first_name: "Sneha",
          last_name: "Gupta",
        },
        price_parent: 60000,
        paid_amount: 45000,
      },
      {
        id: 5,
        auth_user: {
          first_name: "Vikram",
          last_name: "Singh",
        },
        price_parent: 55000,
        paid_amount: 55000,
      },
      {
        id: 6,
        auth_user: {
          first_name: "Deepak",
          last_name: "Joshi",
        },
        price_parent: 80000,
        paid_amount: 30000,
      },
      {
        id: 7,
        auth_user: {
          first_name: "Kavita",
          last_name: "Patel",
        },
        price_parent: 45000,
        paid_amount: 40000,
      },
    ];
  }

  async get() {
    try {
      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      return {
        data: {
          data: this.staticData,
        },
      };
    } catch (error) {
      console.error("Error fetching client balance data:", error);
      throw error;
    }
  }
};

export default new ClientBalanceModel();
